import React, { memo, useState, useEffect, useCallback, useRef } from 'react';
import { useHistory } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { createSelector } from 'reselect';
import KeepAlive, { useActivate, useUnactivate } from 'react-activation';

import styles from './CategoryPCCard.module.less';
import GameRate from '../../GameRate/GameRate';
import Button from '../../Button/Button';
import TimeImg from '../../../static/game/game_time.svg';
import TagImg from '../../../static/game/game_tag.svg';
import DownloadImg from '../../../static/game/game_download.svg';
import CommentsImg from '../../../static/game/game_positive_comments.svg';
import { CONTEXT } from '../../../config';
import _LogInView from '../../_LogInView/_LogInView';
import loading from '../../../static/loading.gif';
import DefaultImg from '../../../static/game/game_item_default.png';
import { logging, logPostInfo } from '../../../actions/log';
import { addClass, getSoftType } from '../../../utils/utils';

const selectLogInfo = createSelector(
  state => state.log,
  log => log.logInfo,
);

export default memo(({ soft, logInfo }) => {
  const dispatch = useDispatch();
  const [isHover, setIsHover] = useState(false);
  const history = useHistory();
  const [showImg, setShowImg] = useState();
  const logInfoData = useSelector(selectLogInfo);
  const node = useRef(null);

  useEffect(() => {
    show().then(res => {
      setShowImg(res);
    });
    return () => {
      setIsHover(false);
    };
  }, []);

  const formatPriceType3 = useCallback((num = '0') => {
    return parseFloat((num || '0')?.replace('¥', '').replace('￥', ''));
  }, []);

  const formatPrice = useCallback((num = '0') => {
    return `${parseFloat((parseInt(num) / 100).toFixed(2)) || 0}`;
  }, []);
  const formatPriceZK = useCallback((cu, or) => {
    let c = parseFloat(cu);
    let o = parseFloat(or);
    if (c && o) {
      return `${parseFloat((c / o).toFixed(2)) * 10 || 0}`;
    }
    return '';
  }, []);

  const handleApp = () => {
    history.push(`${CONTEXT}/detail/soft/${soft.softID}/${soft.bizInfo || '{}'}`);
    const source = logInfo ? logInfo.source : 'SoftCard_err';
    dispatch(
      logging({
        category: 'C',
        action: 'handle_SoftCard',
        label: '',
        param2: {
          ...logInfo,
          softid: soft.softID,
          softType: getSoftType(soft),
          source: logInfo.source,
          source_p: logInfoData.source_p,
          source_pp: logInfoData.source_pp,
        },
        param3: soft.bizInfo,
      }),
    );
    dispatch(
      logPostInfo({
        source_p: source,
        source_pp: logInfoData.source_p,
      }),
    );
  };

  const show = () => {
    return new Promise((re, rj) => {
      const img = new Image();
      img.onload = () => re(soft?.ztImg ?? soft?.captureFileList?.[0]);
      img.src = loading;
    });
  };

  const onMouseLeave = useCallback(
    e => {
      const el = e.currentTarget;
      addClass(node.current, styles.image_mouse_out);
      setIsHover(false);
    },
    [node],
  );

  useActivate(() => {
    if (isHover) {
      setIsHover(false);
    }
  });

  return (
    <div
      className={`${styles.CategoryPC_card} ${isHover ? styles.image_mouse_in : ''}  `}
      onMouseEnter={() => setIsHover(true)}
      onMouseLeave={e => onMouseLeave(e)}
      onMouseMove={() => setIsHover(true)}
      onClick={handleApp}
    >
      <div className="card_img" ref={node}>
        <div className="card_mask" />
        <img src={showImg} onError={() => setShowImg(DefaultImg)} className={styles.bj_img} />

        {soft?.androidType === '3' && soft?.sourceInfo && soft?.sourceInfo?.sellInfo && (
          <div className="card_sellInfo">
            {soft?.sourceInfo?.sellInfo?.discount && (
              <div className="discount">
                {soft?.sourceInfo?.sellInfo?.discount} 折
                {/* <div className="discount_show"></div> */}
              </div>
            )}
            {soft?.sourceInfo?.sellInfo?.currentPrice ===
              soft?.sourceInfo?.sellInfo?.originalPrice && (
              <>
                {(soft?.sourceInfo?.sellInfo?.currentPrice &&
                  !soft?.sourceInfo?.sellInfo?.originalPrice) ||
                  (!soft?.sourceInfo?.sellInfo?.currentPrice &&
                    soft?.sourceInfo?.sellInfo?.originalPrice && (
                      <div className="current_price">
                        ¥
                        {formatPriceType3(
                          soft?.sourceInfo?.sellInfo?.currentPrice ||
                            soft?.sourceInfo?.sellInfo?.originalPrice,
                        )}
                      </div>
                    ))}
                {soft?.sourceInfo?.sellInfo?.currentPrice &&
                  soft?.sourceInfo?.sellInfo?.originalPrice && (
                    <div className="current_price">
                      ¥{formatPriceType3(soft?.sourceInfo?.sellInfo?.currentPrice)}
                    </div>
                  )}
              </>
            )}
            {soft?.sourceInfo?.sellInfo?.currentPrice !==
              soft?.sourceInfo?.sellInfo?.originalPrice && (
              <>
                {soft?.sourceInfo?.sellInfo?.currentPrice &&
                  !soft?.sourceInfo?.sellInfo?.originalPrice && (
                    <div className="current_price">
                      ¥{formatPriceType3(soft?.sourceInfo?.sellInfo?.currentPrice)}
                    </div>
                  )}
                {!soft?.sourceInfo?.sellInfo?.currentPrice &&
                  soft?.sourceInfo?.sellInfo?.originalPrice && (
                    <div className="current_price">
                      ¥{formatPriceType3(soft?.sourceInfo?.sellInfo?.originalPrice)}
                    </div>
                  )}
                {soft?.sourceInfo?.sellInfo?.currentPrice &&
                  soft?.sourceInfo?.sellInfo?.originalPrice && (
                    <>
                      <div className={`current_price`}>
                        ¥{formatPriceType3(soft?.sourceInfo?.sellInfo?.currentPrice)}
                      </div>
                      <div className={`original_price`}>
                        ¥{formatPriceType3(soft?.sourceInfo?.sellInfo?.originalPrice)}
                      </div>
                    </>
                  )}
              </>
            )}
          </div>
        )}
        {soft && soft.payType === 1 && (
          <div className="card_sellInfo">
            {soft?.currentPrice &&
              soft?.originalPrice &&
              soft?.currentPrice !== soft?.originalPrice && (
                <div className="discount">
                  {formatPriceZK(soft?.currentPrice, soft?.originalPrice)} 折
                  {/* <div className="discount_show">
                    {formatPriceZK(soft?.currentPrice, soft?.originalPrice)} 折
                  </div> */}
                </div>
              )}
            {((!soft?.currentPrice && soft?.originalPrice) ||
              (soft?.currentPrice && !soft?.originalPrice) ||
              soft?.currentPrice === soft?.originalPrice) && (
              <div className={`current_price`}>
                ¥{formatPrice(soft?.currentPrice || soft?.originalPrice)}
              </div>
            )}
            {soft?.currentPrice &&
              soft?.originalPrice &&
              soft?.currentPrice !== soft?.originalPrice && (
                <>
                  <div className={`current_price`}>¥{formatPrice(soft?.currentPrice)}</div>
                  <div className={`original_price`}>¥{formatPrice(soft?.originalPrice)}</div>
                </>
              )}
          </div>
        )}
      </div>
      <div className="card_info">
        {isHover && (
          <div className={`${styles.hover} hover_info`}>
            <div className="hover_name">{soft?.softName}</div>
            <div className="hover_row">
              <img src={TimeImg} />
              <div>{soft?.createdTime.slice(0, 10)}更新</div>
            </div>
            <div className="hover_row">
              <img src={CommentsImg} />
              {soft?.scoreRadio > 70 ? (
                <div>{soft?.scoreRadio}%好评率</div>
              ) : (
                <GameRate score={(Number(soft?.score) / 20).toFixed(1)} />
              )}
            </div>
            <div className="hover_row">
              <img src={DownloadImg} />
              <div>{soft?.downloadCount}安装</div>
            </div>
            {soft.relationTags?.length > 0 && (
              <div className="hover_row">
                <img src={TagImg} />
                <div className="tag_list">
                  {soft.relationTags.map((tag, i) => (
                    <div key={i} className="tag_name">
                      {tag.name}
                    </div>
                  ))}
                </div>
              </div>
            )}
            {!soft?.relationTags?.length && (
              <div className="hover_row">
                <img src={TagImg} /> <div className="introduction">{soft?.introduction}</div>
              </div>
            )}

            <div
              className="hover_btn"
              onClick={e => {
                e.stopPropagation();
                e.preventDefault();
              }}
            >
              <Button
                soft={soft}
                info={{
                  btnStyle: 'black',
                  className: styles.btn,
                  className_busing: styles.btn,
                  className_open: styles.btn,
                }}
                logInfo={{ ...logInfo, softId: soft.softID }}
              />
            </div>
          </div>
        )}

        <div className="no_hover">
          <div className="no_hover_name">{soft?.softName}</div>
          <div className="no_hover_download">
            <GameRate score={(Number(soft?.score) / 20).toFixed(1)} />
            <div className="download">{soft?.downloadCount}安装</div>
          </div>
          {soft?.relationTags?.length > 0 ? (
            <div className="no_hover_tag">
              <div className="tag_list">
                {soft.relationTags.map((tag, i) => (
                  <div key={i} className="tag_name">
                    {tag.name}
                  </div>
                ))}
              </div>
            </div>
          ) : (
            <div className="no_tag">{soft?.introduction}</div>
          )}
        </div>
      </div>
    </div>
  );
});
